import { create } from "zustand";
import type { OpportunitiesState } from "./types";

const useOpportunitiesStore = create<OpportunitiesState>((set, get) => ({
    opportunitiesData: undefined,
    refreshKey: 0,
    setOpportunitiesData: (data) => set({ opportunitiesData: data }),
    triggerRefresh: () => set((s) => ({ refreshKey: s.refreshKey + 1 })),
    findOpportunityByName: (name) => {
        const data = get().opportunitiesData;
        if (!data) return undefined;
        return data.objectives.find((opportunity) => opportunity.title === name);
    },
}));

export { useOpportunitiesStore };
